module.exports = function (func, wait) {
    let timeout
    let values = []
    return function (value) {
        values.push(value)

        const context = this

        clearTimeout(timeout)

        const later = function () {
            const _values = values
            values = []
            timeout = null
            func.apply(context, [_values])
        }

        timeout = setTimeout(later, wait)
    }
}


// WEBPACK FOOTER //
// ./resources/assets/javascript/microsistec/debounce-acc.js